import React, { Component } from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Helmet from 'react-helmet';
import moment from 'moment';
import config from 'config';
import queryString from 'query-string';

import { redirect } from 'widgets/I18nLink';
import { buildApiParams, buildSearchParams, detectBootstrapScreen, findCityById } from 'utils';
import { toTimezone } from 'utils/dates';

import OrderStepsSection from 'widgets/OrderStepsSection';
import SearchForm from 'widgets/SearchForm';
import MapWithMarkers from 'widgets/MapWithMarkers';
import Dialog from 'widgets/Dialog';

import SearchResults from './SearchResults';
import SearchMap from './SearchMap';
import SubscribeBlock from './SubsctibeBlock';

import './SearchPage.css';

const ORDER_TYPES = [
  {
    title: 'recommended',
    value: 'recommended'
  },
  {
    title: 'from low to high',
    value: 'price'
  },
  {
    title: 'from high to low',
    value: '-price'
  }
];

class SearchPage extends Component {
  constructor(...args) {
    super(...args);
    this.searchFormSubmitHandler = this.onSearchSubmit.bind(this);
    this.resizeWindowHandler = this.onResizeWindow.bind(this);
    this.toggleSearchFormOpenXsScreenHandler = this.toggleSearchFormOpenXsScreen.bind(this);
    this.loadMoreHandler = this.loadMore.bind(this);
    this.toggleViewHandler = this.toggleView.bind(this);
    this.showBikeOnMapHandler = this.onShowBikeOnMap.bind(this);
    this.closeBikeOnMapHandler = this.onCloseBikeOnMap.bind(this);
    this.bikesListSelectHandler = this.onBikeSelect.bind(this, true);
    this.bikesMapSelectHandler = this.onBikeSelect.bind(this, true);

    this.state = {
      openSearchFormXsScreen: false,
      screen: null,
      activeOrderType: ORDER_TYPES[0].value,
      view: 'list',
      searchParams: {},
      selectedBike: null
    };
  }

  // check dates, redirect if dates stale
  componentWillReceiveProps(nextProps) {
    if (nextProps.countries !== this.props.countries || this.props.location.query !== nextProps.location.query) {
      const searchParams = buildSearchParams(nextProps.location.query, nextProps.countries);

      const result = this.validateDateRange(searchParams);

      if (result.needRedirect) {
        this.onSearchSubmit(result.searchParams);
      }

      this.setState({ searchParams });
    }
  }

  // validate date range & redirect
  componentWillMount() {
    const searchParams = buildSearchParams(this.props.location.query, this.props.countries);
    const result = this.validateDateRange(searchParams);

    if (result.needRedirect) {
      const nextSearch = queryString.stringify(this.filtersToQuery(result.searchParams));
      global.redirectTo = `${this.props.location.pathname}?${nextSearch}`;
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindowHandler);
    this.onResizeWindow();

    if (this.props.location.query && this.props.countries) {
      const searchParams = buildSearchParams(this.props.location.query, this.props.countries);

      const result = this.validateDateRange(searchParams);
      if (result.needRedirect) {
        this.onSearchSubmit(result.searchParams);
      }

      this.setState({
        searchParams,
        activeOrderType: searchParams.ordering || ORDER_TYPES[0].title
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindowHandler);
  }

  filtersToQuery(data) {
    return {
      bikeTypes: data.bikeTypes.join(','),
      country: data.country,
      pickUpCity: data.pickUpCity,
      dropOfCity: data.dropOfCity,
      returnAtSameCity: data.returnAtSameCity,
      begin: moment(data.beginDateTime).toISOString(),
      end: moment(data.endDateTime).toISOString(),
      age: data.age,
      ordering: this.state.activeOrderType,
      code: this.state.searchParams.code
    };
  }

  validateDateRange(searchParams) {
    const minBegin = moment()
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .add(1, 'hour')
      .add(config.minimalBookingOffset, 'hour');

    const newSearchParams = {};

    if (moment(searchParams.beginDateTime).isBefore(minBegin)) {
      newSearchParams.beginDateTime = minBegin;
    }

    if (!moment(searchParams.endDateTime).isAfter(moment(newSearchParams.beginDateTime))) {
      newSearchParams.endDateTime = moment(newSearchParams.beginDateTime).add(1, 'hours');
    }

    return {
      needRedirect: !!Object.keys(newSearchParams).length,
      searchParams: { ...searchParams, ...newSearchParams }
    };
  }

  onResizeWindow() {
    const screen = detectBootstrapScreen();

    if (this.state.screen !== screen) {
      this.setState({ screen });
    }
  }

  onSearchSubmit(data) {
    redirect({
      pathname: '/search/',
      query: this.filtersToQuery(data)
    });
  }

  toggleSearchFormOpenXsScreen() {
    this.setState((prevState) => ({
      openSearchFormXsScreen: !prevState.openSearchFormXsScreen
    }));
  }

  loadResults(props, clear = false) {
    if (clear) {
      props.clearSearchResults();
    }

    if (!props.countries) {
      return;
    }

    const { query } = props.location;

    if (!query) {
      return;
    }

    const searchParams = buildSearchParams(query, props.countries);
    props.loadSearchResults(buildApiParams(searchParams));

    this.setState({
      searchParams,
      activeOrderType: searchParams.ordering || ORDER_TYPES[0].title
    });
  }

  loadMore(event) {
    event.preventDefault();
    this.loadResults(this.props);
  }

  toggleView() {
    this.setState((prevState) => ({
      view: prevState.view === 'list' ? 'map' : 'list'
    }));
  }

  changeOrder(activeOrderType) {
    this.setState(
      { activeOrderType },
      () => this.onSearchSubmit(this.state.searchParams)
    );
  }

  onShowBikeOnMap(selectedBike) {
    this.setState({ selectedBike });
  }

  onCloseBikeOnMap() {
    this.setState({ selectedBike: null });
  }

  onBikeSelect(newWindow, bike) {
    const { location } = this.props;
    const pathname = `/detail/${bike.id}/`;
    const query = Object.assign({}, location.query, { extras: null });

    if (newWindow) {
      const lang = location.pathname.split('/')[1];
      window.open(`/${lang}${pathname}?${queryString.stringify(query)}`, '_blank');
    } else {
      redirect({ pathname, query });
    }
  }

  addTimezone(datetime, tz) {
    tz = tz || 'UTC';
    return toTimezone(datetime, tz);
  }

  render() {
    const {
      t,
      countries,
      currency,
      isModerator,
      isFetchingList,
      searchResults
    } = this.props;

    const {
      activeOrderType,
      view,
      searchParams,
      selectedBike,
      screen,
      openSearchFormXsScreen
    } = this.state;

    const orderType = ORDER_TYPES.find((el) => el.value === activeOrderType);
    const bikeTypes = this.props.bikeTypes || [];

    const {
      pickUpCity: pickUpCityId,
      dropOfCity: dropOfCityId,
      beginDateTime,
      endDateTime
    } = searchParams;

    const pickUpCity = findCityById(countries, pickUpCityId);
    const dropOfCity = findCityById(countries, dropOfCityId);

    let orderParamsString = '';

    if (pickUpCity && dropOfCity && beginDateTime && endDateTime) {
      const cityStr = t(pickUpCity.name, { cn: 'cities' });
      const showTimezone = pickUpCity.timezoneName !== dropOfCity.timezoneName;
      const dtFormat = showTimezone ? 'D MMMM YYYY HH:mm UTCZ' : 'D MMMM YYYY HH:mm';

      const fromTime = this.addTimezone(beginDateTime, pickUpCity.timezoneName);
      const fromStr = fromTime.format(dtFormat);

      const toTime = this.addTimezone(endDateTime, dropOfCity.timezoneName);
      const toStr = toTime.format(dtFormat);

      orderParamsString = `${cityStr} ${t('from')} ${fromStr} ${t('to')}`;

      if (pickUpCity.id !== dropOfCity.id) {
        orderParamsString += ` ${t(dropOfCity.name, { cn: 'cities' })}`;
      }

      orderParamsString += ` ${toStr}`;
    }

    const canLoadMore = searchResults && !!searchResults.nextPage;
    const items = !!searchResults ? searchResults.results : [];

    return (
      <div className="search-page">
        <Helmet
          meta={[{
            name: 'robots',
            content: 'noindex, follow'
          }]}
        />

        <OrderStepsSection
          activeStep={1}
          orderParamsString={orderParamsString}
          title={t('Search rentals')}
        />

        <div className="form-section">
          <Grid>
            <span
              className="show-search-form-btn"
              onClick={this.toggleSearchFormOpenXsScreenHandler}
            >
              {openSearchFormXsScreen ? t('Hide search form') : t('Show search form')}
            </span>

            {((screen !== 'xs') || openSearchFormXsScreen) && (
              <SearchForm
                bikeTypes={bikeTypes}
                className="horizontal"
                countries={countries}
                initialState={searchParams}
                onSubmit={this.searchFormSubmitHandler}
              />
            )}
          </Grid>
        </div>

        <div className="search-content-section">
          <Grid>
            {!!items.length && (
              <div className="clearfix search-settings">
                <div className="search-view">
                  {t('Show') + ' '}

                  {(view === 'list') && (
                    <span
                      className="search-view-map"
                      onClick={this.toggleViewHandler}
                    >
                      {t('on the map')}
                    </span>
                  )}

                  {(view === 'map') && (
                    <span
                      className="search-view-list"
                      onClick={this.toggleViewHandler}
                    >
                      {t('as a list')}
                    </span>
                  )}
                </div>

                <div className="search-order">
                  {t('Order by') + ' '}
                  <DropdownButton
                    id="OrderSelect"
                    bsStyle="link"
                    pullRight={true}
                    title={t(orderType.title)}
                  >
                    {ORDER_TYPES.map((el) => (
                      <MenuItem
                        key={el.value}
                        eventKey={el.value}
                        active={activeOrderType === el.value}
                        onClick={this.changeOrder.bind(this, el.value)}
                      >
                        {t(el.title)}
                      </MenuItem>
                    ))}
                  </DropdownButton>
                </div>
              </div>
            )}

            {(view === 'list') && (
              <SearchResults
                currency={currency}
                bikeTypes={bikeTypes}
                isModerator={isModerator}
                isFetching={isFetchingList}
                items={items}
                loadMore={this.loadMoreHandler}
                canLoadMore={!!items.length && canLoadMore}
                onShowBikeOnMap={this.showBikeOnMapHandler}
                onSelect={this.bikesListSelectHandler}
              />
            )}

            {(view === 'map') && (
              <div className="search-map-block">
                <SearchMap
                  currency={currency}
                  countries={countries}
                  initialState={searchParams}
                  isFetching={this.props.isFetchingMap}
                  items={this.props.searchResultsMap}
                  loadSearchResultsMap={this.props.loadSearchResultsMap}
                  clearSearchResultsMap={this.props.clearSearchResultsMap}
                  onSelect={this.bikesMapSelectHandler}
                />
              </div>
            )}

            <SubscribeBlock />
          </Grid>
        </div>

        <Dialog
          open={!!selectedBike}
          onClose={this.closeBikeOnMapHandler}
        >
          {!!selectedBike && (
            <MapWithMarkers
              zoom={14}
              markers={[{
                position: {
                  lat: selectedBike.company.lat,
                  lng: selectedBike.company.lng
                }
              }]}
            />
          )}
        </Dialog>
      </div>
    );
  }
}

export default SearchPage;



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPage.js